import { API } from "../urls";

const fetchOpts = { credentials: "include" };

export const fetchAuditLogs = async (params) => {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );
    const res = await fetch(`${API.audit_logs}?${query}`, { ...fetchOpts });
    return res.json();
};

/** Tek kaydın tamamı: değişen alanlar, olay bilgileri, IP ve tarayıcı. */
export const fetchAuditLogDetail = async (id) => {
    const res = await fetch(API.audit_log_detail(id), { ...fetchOpts });
    return res.json();
};
